import { render, staticRenderFns } from "./AddressManualForm.vue?vue&type=template&id=fa419120&scoped=true&"
import script from "./AddressManualForm.vue?vue&type=script&lang=js&"
export * from "./AddressManualForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa419120",
  null
  
)

export default component.exports